module.exports = __webpack_public_path__ + "static/img/businessAddress.f28802bf.png";